import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-carvet-up-down",
  "use": "arrow-carvet-up-down-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-carvet-up-down\"><path d=\"M5.147 6.146A.5.5 0 005.501 7h6a.5.5 0 00.354-.854l-3-3a.5.5 0 00-.708 0l-3 3zm6.708 4.708A.5.5 0 0011.5 10h-6a.5.5 0 00-.354.854l3 3a.5.5 0 00.708 0l3-3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol